import React from "react";
import { presetsFor, getDefaultPreset, type LabelKind, type LabelPreset } from "../lib/labels";

export function LabelPicker({
  frameSelected,
  selectedKey,
  onChange,
  onReset,
}: {
  frameSelected: boolean;
  selectedKey: string | null;
  onChange: (key: string) => void;
  onReset?: () => void;
}) {
  const kind: LabelKind = frameSelected ? "framed" : "square";
  const presets: LabelPreset[] = presetsFor(kind);
  const def = getDefaultPreset(kind);
  const value = selectedKey || def.key;

  return (
    <div className="oo-field">
      <label htmlFor="labelPreset">Label preset</label>
      <div className="flex items-center gap-2">
        <select
          id="labelPreset"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          {presets.map((p) => (
            <option key={p.key} value={p.key}>{`${p.code} — ${p.widthIn}\" × ${p.heightIn}\" — ${p.perSheet}/sheet`}</option>
          ))}
        </select>
        {onReset ? (
          <button type="button" className="btn" onClick={onReset}>Reset default</button>
        ) : null}
      </div>
    </div>
  );
}

export default LabelPicker;


